export enum UserRoleEnum {
  CarrierSalesRep = 'CarrierSalesRep',
  CustomerSalesRep = 'CustomerSalesRep',
  Dispatcher = 'Dispatcher',
  Driver = 'Driver',
  OwnerOperator = 'OwnerOperator',
  ShipperSalesRep = 'ShipperSalesRep'
}

export interface IWorkspaceMember {
  accessType?: string
  status?: string
  user?: {
    countryCode?: string
    email?: string
    id: string
    name?: string
    phone?: string
    photo?: string
    username?: string
  } | null
  userID: string
  workspaceID: string
}

export interface IUserWorkspace {
  displayName?: string | null
  id?: string
  isVerified?: boolean
  logo?: string | null
  name?: string
  workspacename?: string | null
}

export interface UserAvatarProps {
  showOnlineBadge?: boolean
  showTooltip?: boolean
  size?: 'xs' | 'sm' | 'lg' | 'md' | 'xl' | '2xl' | '2xs' | null | undefined
  user: {
    email?: string
    id?: string
    name?: string
    online?: boolean
    phone?: string
    photo?: string | null
  }
  variant?: 'square' | 'basic'
  workspace?: IUserWorkspace
}
